import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAgent = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	viewBox: "0 0 20 20",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0)",
			children: [
				/* @__PURE__ */ _jsx("g", {
					className: "circle",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M9.51679 13.5621C9.51679 11.8691 8.16817 10.4936 6.50833 10.4936C6.24079 10.4936 6.02239 10.2708 6.02239 9.99791C6.02239 9.72503 6.24079 9.50226 6.50833 9.50226C8.16817 9.50226 9.51679 8.1267 9.51679 6.43369C9.51679 6.16081 9.73519 5.93804 10.0027 5.93804C10.2703 5.93804 10.4887 6.16081 10.4887 6.43369C10.4887 8.1267 11.8373 9.50226 13.4971 9.50226C13.7647 9.50226 13.9831 9.72503 13.9831 9.99791C13.9831 10.2708 13.7647 10.4936 13.4971 10.4936C11.8373 10.4936 10.4887 11.8691 10.4887 13.5621C10.4887 13.835 10.2703 14.0578 10.0027 14.0578C9.73519 14.0578 9.51679 13.835 9.51679 13.5621ZM10.0027 11.6241C10.3686 10.9391 10.9255 10.3766 11.5916 10.0035C10.92 9.63035 10.3686 9.0623 10.0027 8.38287C9.63691 9.06787 9.07999 9.63035 8.41387 10.0035C9.08545 10.3766 9.63691 10.9447 10.0027 11.6241Z",
						fill: "currentColor"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					className: "arrow-ur",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M11.5643 1.58301C11.3732 1.3881 11.3732 1.07623 11.5643 0.881309L12.1977 0.235294C12.3888 0.0403759 12.6945 0.0403759 12.8856 0.235294C13.0767 0.430212 13.0767 0.742081 12.8856 0.937L12.2523 1.58301C12.1594 1.67769 12.0339 1.72781 11.9083 1.72781C11.7827 1.72781 11.6626 1.67769 11.5643 1.58301ZM9.75157 2.73582C9.56047 2.93073 9.56047 3.2426 9.75157 3.43752C9.84439 3.5322 9.96997 3.58232 10.0955 3.58232C10.2211 3.58232 10.3412 3.5322 10.4395 3.43752L11.0729 2.79151C11.264 2.59659 11.264 2.28472 11.0729 2.0898C10.8818 1.89488 10.576 1.89488 10.3849 2.0898L9.75157 2.73582ZM13.5026 3.36512H14.1742C14.4417 3.36512 14.6601 3.14236 14.6601 2.86947C14.6601 2.59659 14.4417 2.37383 14.1742 2.37383H12.3287C12.2632 2.37383 12.2031 2.38496 12.1431 2.41281C12.0229 2.46293 11.9301 2.55761 11.881 2.68013C11.8591 2.74139 11.8428 2.80265 11.8428 2.86947V4.75183C11.8428 5.02471 12.0612 5.24748 12.3287 5.24748C12.5962 5.24748 12.8146 5.02471 12.8146 4.75183V4.06683L18.6295 9.99791L9.65329 19.1535C9.46219 19.3484 9.46219 19.6603 9.65329 19.8552C9.74611 19.9499 9.87169 20 9.99727 20C10.1229 20 10.243 19.9499 10.3412 19.8552L20 10.0035L13.4971 3.37069L13.5026 3.36512Z",
						fill: "currentColor"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					className: "arrow-dl",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M7.75321 18.4184L7.11985 19.0644C6.92875 19.2593 6.92875 19.5712 7.11985 19.7661C7.21267 19.8608 7.33825 19.9109 7.46383 19.9109C7.58941 19.9109 7.70953 19.8608 7.80781 19.7661L8.44117 19.1201C8.63227 18.9252 8.63227 18.6133 8.44117 18.4184C8.25007 18.2235 7.94431 18.2235 7.75321 18.4184ZM10.2539 17.2656C10.445 17.0707 10.445 16.7588 10.2539 16.5639C10.0628 16.369 9.75703 16.369 9.56593 16.5639L8.93257 17.2099C8.74147 17.4048 8.74147 17.7167 8.93257 17.9116C9.02539 18.0063 9.15097 18.0564 9.27655 18.0564C9.40213 18.0564 9.52225 18.0063 9.62053 17.9116L10.2539 17.2656ZM7.85695 17.583C7.97707 17.5329 8.06989 17.4382 8.11903 17.3157C8.14087 17.2544 8.15725 17.1932 8.15725 17.1263V15.244C8.15725 14.9711 7.93885 14.7483 7.67131 14.7483C7.40377 14.7483 7.18537 14.9711 7.18537 15.244V15.929L1.37046 9.99791L10.3467 0.847894C10.5378 0.652976 10.5378 0.341107 10.3467 0.146189C10.1556 -0.0487296 9.84985 -0.0487296 9.65875 0.146189L0 9.99791L6.50287 16.6307H5.83129C5.56375 16.6307 5.34534 16.8535 5.34534 17.1263C5.34534 17.3992 5.56375 17.622 5.83129 17.622H7.67677C7.74229 17.622 7.80235 17.6109 7.86241 17.583H7.85695Z",
						fill: "currentColor"
					})
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 20,
				height: 20,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgAgent);
export default ForwardRef;
